import React from 'react';

const TakeawayIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <g transform="scale(0.5)">
      <path d="M37.7 11.1A3 3 0 0 0 35.4 10H34.2l.3-1.7A3.1 3.1 0 0 0 33.9 6a3.2 3.2 0 0 0-2.2-1H7.8a2 2 0 0 0 0 4h22.5l-4 22.9a6.8 6.8 0 0 0-1 2.1H20.7A7 7 0 0 0 7.3 34H6.2l.5-2.9a2 2 0 0 0-1.6-2.3 2 2 0 0 0-2.3 1.6L2 34.7A2.8 2.8 0 0 0 2.7 37a2.8 2.8 0 0 0 2.1 1H7.3a7 7 0 0 0 13.4 0h4.6a7 7 0 0 0 13.4 0h2a3.2 3.2 0 0 0 3.1-2.7L46 22.5Z" />
      <path d="M14 39a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
      <path d="M32 39a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
      <path d="M33.5 14h1.3l5.9 8H32.1Z" />
      <path d="M4 15h10" />
      <path d="M5 19h8" />
      <path d="M6 23h6" />
    </g>
  </svg>
);

export default TakeawayIcon;
